import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { HELP_CENTER_SUNCO_INTEGRATION_ID_230130 } from "@faire/web-api/indigofair/settings/HELP_CENTER_SUNCO_INTEGRATION_ID_230130";
export function getSettingSunCoIntegrationId() {
  return getSettingValueWithoutAssignment(HELP_CENTER_SUNCO_INTEGRATION_ID_230130, "636d4f414f9e0101044f41a3");
}